import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import NavBar from "./navbar";
import "./projects.css";
import Footer from "./footer";

function Projects() {
  return (
    <div>
      <NavBar />
      <div className="projects-header" style={{ marginBottom: "-5%", marginTop: "1%", alignItems: "left" }}>
        <h1>
          <b>Projects</b>
        </h1>
        <p>
          My open source contributions and projects built during internships and
          university work.
        </p>
      </div>
      <div className="card-container">
        <Row>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "29rem",
                  marginTop: "5%",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/GSoCLogo.png" />
                <Card.Body>
                  <Card.Title style={{ textAlign: "left" }}>
                    <b>Google Summer of Code 2021</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left", color: "white" }}>
                    Implementation of 3D visualization support and integration
                    with the MapMint instance. The 3D scenes are rendered with
                    Potree Loaders along with Cesium as the backend.
                    <a href="https://summerofcode.withgoogle.com/archive/2021/projects/6036322531147776">
                      <h5 style={{ fontSize: "15px", marginTop: "3%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "29rem",
                  marginTop: "5%",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/x.jpeg" />
                <Card.Body>
                  <Card.Title style={{ textAlign: "left" }}>
                    <b>CoVAC: Covid Vaccine Availability Checker</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left", color: "white" }}>
                    CoVAC is an android application developed to provide users
                    the facility to check the available slots for various
                    vaccines with their corresponding Postal Codes of India.
                    <a href="https://github.com/aryanxk02/CoVAC">
                      <h5 style={{ fontSize: "15px", marginTop: "3%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <div className="card-container">
        <Row>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "29rem",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/heart.jpg" />
                <Card.Body>
                  <Card.Title style={{ textAlign: "left", marginTop: "-2%" }}>
                    <b>Hybrid Approach for Predicting Heart Failure</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left" }}>
                    This research focuses on a majority based algorithm that
                    uses the 3 best performing machine learning models out of 10
                    classification-based models to predict heart failure.
                    <a href="https://github.com/aryanxk02/Heart-Failure-Prediction">
                      <h5 style={{ fontSize: "15px", marginTop: "2%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                  {/* <Button variant="primary">Go somewhere</Button> */}
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "29rem",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/BCP.jpeg" />
                <Card.Body>
                  <Card.Title style={{ textAlign: "left" }}>
                    <b>Comparative Study of ML Algorithms</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left" }}>
                    This paper compares the performance of multiple ML models
                    with the use of different filters for the detection of
                    breast cancer using Logistic Regression, Extreme Gradient
                    Boosting, and other data manipulation techniques.
                    <a href="https://github.com/aryanxk02/Breast-Cancer-Detection">
                      <h5 style={{ fontSize: "15px", marginTop: "3%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <div className="card-container">
        <Row>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "28rem",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/x.jpeg" />
                <Card.Body>
                  <Card.Title>
                    <b>Retinal Scans Classification</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left" }}>
                    Developed an app for classification of retinal scans and
                    early detection of various eye diseases via an ensemble of
                    deep learning models. The app manages patient records
                    through a web portal.
                    <a href="#">
                      <h5 style={{ fontSize: "15px", marginTop: "3%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col>
            <div>
              <Card
                border="light"
                style={{
                  width: "25rem",
                  height: "28rem",
                  backgroundColor: "#212529",
                }}
              >
                <Card.Img variant="top" src="./images/CrowdSec.png" />
                <Card.Body>
                  <Card.Title>
                    <b>CrowdSec Splunk App</b>
                  </Card.Title>
                  <Card.Text style={{ textAlign: "left" }}>
                    The CrowdSec Splunk app leverages the CrowdSec's CTI API's
                    smoke endpoint enabling users to query an IP – brief overview of various fields
                    associated with the input IP address.
                    <a href="https://github.com/crowdsecurity/crowdsec-splunk-app">
                      <h5 style={{ fontSize: "15px", marginTop: "3%" }}>
                        Learn more →
                      </h5>
                    </a>
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  );
}

export default Projects;
